import { ACTION_AUTHEN_TOKEN_EXPIRE, ACTION_AUTHEN_VERIFY_TOKEN, ACTION_AUTHEN_VERIFY_TOKEN_ERROR, ACTION_AUTHEN_VERIFY_TOKEN_SUCCESS } from "../actions"

const initState = {
    erro_msg: undefined,
    data: undefined,
    isLoading: false
}

export const verifyTokenReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_AUTHEN_VERIFY_TOKEN:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_AUTHEN_VERIFY_TOKEN_SUCCESS:
            let data =  {}
            data[action.payload.data.app.gate + "_" + action.payload.data.app.appid] = action.payload.data.data;
            return { ...state, isLoading: false, erro_msg: undefined, data: data }
        case ACTION_AUTHEN_VERIFY_TOKEN_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg }
        case ACTION_AUTHEN_TOKEN_EXPIRE:
            return { ...state, isLoading: false, erro_msg: undefined, data: undefined }
        default:
            return state;
    }
}